import modelRequest, { RequestError } from './lib/modelRequest'

/**
 * Donuts response
 */
interface Donuts {
  phonics: { total: number; completed: number }
  phrases: { total: number; completed: number }
  stories: {
    total: number
    completed: number
    weeks: number
    years: number
    wpmPercentChange: number
  }
}

export default {
  /**
   * Gets donut information
   */
  get: (variables: {
    customerUsername?: string
    studentName?: string
  }): Promise<Donuts & RequestError> => {
    return modelRequest.get('/api/donuts', { params: { ...variables } })
  },
}
